import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import HappySense from 'estimate_list/components/adSense/happySense'
import { useLocation } from "react-router";

const ListCuration = () => {
    const { selectCategory, domain } = useSelector(state => state.initial)
    const { search } = useLocation()

    const attachQueryStringIframeUrl = () => {
        if(search.includes('ad_code')){
            const queryStringAdCode = new URLSearchParams(search).get('ad_code')
            if(queryStringAdCode === 'dap020' || queryStringAdCode === 'dap006'){
                return search
            }
        }
        return ''
    }

    return (
        <>
            <HappySense
                id={selectCategory}
                slot={4517330244}
                responsive={'auto'}
                code_ad={domain === 'shopping' ? 'dap020' : 'dap006'}
                cate_id={selectCategory}
                onlyView={true}
            >
                <div className="adv_top_message border_style">
                    <div>
                        <strong>애드스틱</strong> 광고상품입니다.
                    </div>{' '}
                    <a href="null">광고문의</a>
                </div>
                <Content>
                    <Iframe
                        src={`${process.env.REACT_APP_AD_URL}/${domain === 'shopping' ? 'dap020' : 'dap006'}/${selectCategory}` + attachQueryStringIframeUrl()}
                        className="adv-itembox_conts_frame"
                        title="행복쇼핑"
                        scrolling="no"
                    />
                </Content>
            </HappySense>
        </>
    )
}

const Content = styled.div`
    border: 1px solid #ccc;
    border-top : 0;
`

const Iframe = styled.iframe`
    border: 0;
    width: 100%;
    height: 200px;
    display: block;
`

export default ListCuration



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/list_advstick.js